import React from "react";

import { Icon, Header, Menu, Label } from "semantic-ui-react";

import RouteMenuItem from "../../components/RouteMenuItem";

import ReimbursementModal from "../../components/ReimbursementModal";
import PaymentModal from "../../components/PaymentModal";

import { Route, Redirect, Switch } from "react-router-dom";

import {
  hasCapability,
  APPROVE_REIMBURSEMENTS,
  PAY_REIMBURSEMENTS,
  MODIFY_SUBMITTERS
} from "../../util/capability";

import AllReimbursementsView from "./reimbursements/AllReimbursementsView";
import PeopleView from "./reimbursements/PeopleView";
import PaymentsView from "./reimbursements/PaymentsView";

import { connect } from "react-redux";

import * as _ from "lodash";

const ReimbursementsMenu = props => {
  let widths = 1;
  if (hasCapability(PAY_REIMBURSEMENTS)) widths += 1;
  if (hasCapability(MODIFY_SUBMITTERS)) widths += 1;
  return (
    <Menu fluid widths={widths}>
      <RouteMenuItem exact url="/reimbursements/all">
        All Reimbursements{" "}
        {hasCapability(APPROVE_REIMBURSEMENTS) &&
          props.pendingReimbursementsCount > 0 && (
            <Label color="red" size="mini">
              {props.pendingReimbursementsCount}
            </Label>
          )}
      </RouteMenuItem>
      {hasCapability(PAY_REIMBURSEMENTS) && (
        <RouteMenuItem url="/reimbursements/payments">
          Payments{" "}
          {props.numPendingSubmitters > 0 && (
            <Label color="red" size="mini">
              {props.numPendingSubmitters}
            </Label>
          )}
        </RouteMenuItem>
      )}
      {hasCapability(MODIFY_SUBMITTERS) && (
        <RouteMenuItem url="/reimbursements/people">People</RouteMenuItem>
      )}
    </Menu>
  );
};

const ReimbursementsView = props => {
  return (
    <div>
      <Header as="h2">
        <Icon name="clipboard check" />
        <Header.Content>
          Reimbursements
          <Header.Subheader>
            View, approve, and pay reimbursements.
          </Header.Subheader>
        </Header.Content>
      </Header>
      <ReimbursementsMenu
        pendingReimbursementsCount={props.pendingReimbursements.length}
        numPendingSubmitters={props.numPendingSubmitters} />
      <div style={{ marginTop: "2em" }}>
        <Switch>
          <Route
            exact
            path="/reimbursements/all"
            render={innerProps => (
              <AllReimbursementsView
                {...innerProps}
                resolvedReimbursements={props.resolvedReimbursements}
                pendingReimbursements={props.pendingReimbursements}
                reimbursements={props.reimbursements}
              />
            )}
          />
          <Route path="/reimbursements/payments" component={PaymentsView} />
          <Route path="/reimbursements/people" component={PeopleView} />
          <Route
            path="/reimbursements"
            component={() => <Redirect to="/reimbursements/all" />}
          />
        </Switch>
      </div>
      <div className="reimbursement-modals">
        {props.reimbursements.map(reimbursement => (
          <ReimbursementModal
            reimbursement={reimbursement}
            key={reimbursement.uuid}
            open={props.openedReimbursementModal === reimbursement.uuid} />
        ))}
      </div>
      <div className="payment-modals">
        {props.payments.map(payment => (
          <PaymentModal
            payment={payment}
            key={payment.uuid}
            open={props.openedPaymentModal === payment.uuid} />
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const approvedReimbursements = state.reimbursements.items.filter(
    r => r.status === "approved"
  );
  const groupedByUser = _.groupBy(
    approvedReimbursements,
    r => r.submitter.uuid
  );
  return {
    resolvedReimbursements: state.reimbursements.items.filter(
      r => r.status !== "submitted"
    ),
    pendingReimbursements: state.reimbursements.items.filter(
      r => r.status === "submitted"
    ),
    reimbursements: state.reimbursements.items,
    openedReimbursementModal: state.reimbursements.openedReimbursementModal,
    payments: state.reimbursements.payments,
    openedPaymentModal: state.reimbursements.openedPaymentModal,
    numPendingSubmitters: Object.keys(groupedByUser).length
  };
};

export default connect(mapStateToProps)(ReimbursementsView);



// WEBPACK FOOTER //
// ./frontend/src/views/pages/ReimbursementsView.js